<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg');">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Our Story & Mission</h1>
    <p class="lead" style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Celebrating the rich cultural heritage of Bayou Lacombe and St. Tammany Parish.
    </p>
  </div>
</header>

<main class="container">
  
  <!-- Introduction Section -->
  <section class="story-section">
    <h2>A Rich Heritage</h2>
    <p>
      The geography and history of the Bayou Lacombe region offers the most comprehensive review of these subjects for St. Tammany Parish. From the coastal marshes along Lake Pontchartrain’s shores through the transitions of first cypress swamp and bottom land hardwoods to pine forests, the major bio-geographic communities are represented.
    </p>
    <p>
      Lacombe’s earliest history, found in the shell mounds along the banks of Bayou Lacombe, provide evidence of how native people lived in the region for centuries before the arrival of European settlers.
    </p>
  </section>

  <!-- Mission Highlight -->
  <section class="mission-highlight">
    <h2>Our Mission</h2>
    <p>
      The Bayou Lacombe Museum exists to celebrate and share the rich cultural heritage of our community, connecting the past to our present and future.
    </p>
  </section>

  <!-- Historical Context Section -->
  <section class="story-section" style="border-left-color: var(--color-secondary);">
    <h2>Colonial Roots & Cultural Fusion</h2>
    <p>
      One of the first needs of the early colonists building New Orleans was for materials that could resist the multiple forces of decay found in subtropical Louisiana. From the Choctaw of the North Shore, the colonists learned of the clay and timber resources across Lake Pontchartrain.
    </p>
    <p>
      Within the first quarter century of establishing New Orleans, the first Europeans arrived on the North Shore along Bayou Lacombe to begin manufacturing bricks and cutting cypress and pine forest to build the new city.
    </p>
    <p>
      A few of these French colonists moved across the lake to establish small isolated settlements. One of the first and longest enduring was established at Bayou Lacombe. These early settlers and the native Choctaw formed an amalgamated population. Each with its separate cultural identity, they developed a new shared culture.
    </p>
    <p>
      <strong>La Toussaint</strong>, All Saints’ Day, is an annual Lacombe celebration that combines elements of French Catholic and Choctaw traditions honoring our ancestors. This tradition continues to be celebrated today.
    </p>
  </section>

  <!-- Modern Era Section -->
  <section class="story-section" style="border-left-color: var(--color-primary);">
    <h2>Evolution of a Community</h2>
    <p>
      Throughout the nineteenth century Lacombe has contributed to the development of St. Tammany Parish. It began as a site for brick making and lumber. Building of vessels to transport these goods became a secondary industry. With the arrival of the railroad, timber became a dominant industry.
    </p>
    <p>
      In the twentieth century, Lacombe evolved with the automobile and electricity from an isolated rural fishing community to an exurb and suburb of greater New Orleans. As we move into the twenty-first century, crabbing is still a local industry, but most of the population travels across the region to work in the multitude of businesses from building rockets to caring for the infirmed.
    </p>
    <p>
      The history of Lacombe allows us to tell the important stories of how we are connected to this land and how all of the different peoples from the first to the latest arrivals have contributed to the community.
    </p>
  </section>

</main>
      
                            